import { AvatarIcon } from '../Avatar/AvatarIcon';
import { CoinIcon } from '../../icons/CoinIcon';
import { NetworkImage } from '../Avatar/NetworkImage';
import { BankIcon, ProfileIcon } from '../../icons';
import { ListItem, ListItemAvatar, ListItemProps, ListItemText } from '@mui/material';
import { AvatarBadge } from '../Avatar/AvatarBadge';

export interface CryptoBeneficiaryListItemContentProps {
  network: string;
  currency: string;
  subtype: string | null | undefined;
  displayName: string | null | undefined;
  accountNumber: string;
  beneficiaryName: string | null | undefined;
}

const BADGE_SIZE = 16;

export function CryptoBeneficiaryListItemContent({
  network,
  currency,
  subtype,
  displayName,
  accountNumber,
  beneficiaryName,
}: CryptoBeneficiaryListItemContentProps) {
  const name = displayName ?? beneficiaryName;
  return (
    <>
      <ListItemAvatar>
        <AvatarBadge type="icon" icon={<NetworkImage width={BADGE_SIZE} network={network} />}>
          <AvatarIcon
            icon={
              subtype === 'BUSINESS' ? (
                <BankIcon />
              ) : subtype === 'INDIVIDUAL' ? (
                <ProfileIcon />
              ) : (
                <CoinIcon />
              )
            }
          />
        </AvatarBadge>
      </ListItemAvatar>
      <ListItemText
        primary={`${network} · ${currency}${name ? ` · ${name}` : ''}`}
        secondary={accountNumber}
      />
    </>
  );
}

export type CryptoBeneficiaryListItemProps = ListItemProps<
  'li',
  CryptoBeneficiaryListItemContentProps
>;

export function CryptoBeneficiaryListItem({
  network,
  currency,
  subtype,
  displayName,
  accountNumber,
  beneficiaryName,
  ...props
}: CryptoBeneficiaryListItemProps) {
  return (
    <ListItem {...props}>
      <CryptoBeneficiaryListItemContent
        network={network}
        currency={currency}
        subtype={subtype}
        displayName={displayName}
        accountNumber={accountNumber}
        beneficiaryName={beneficiaryName}
      />
    </ListItem>
  );
}
